import pastasState from './pastasState'
import state from './state'

export default {
    ...pastasState,
    ...state
}